export const uniqueTranslationFromExist = (value, allValues, props) => {
    let {translationsMessageIds} = props
    return translationsMessageIds.indexOf(value) !== -1 ? "The item should be unique" : undefined
}


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/AdminPanel/rules.js